import GenericWidget from "./GenericWidget"

export default GenericWidget
